import { Table } from "@ttc3k/trekker";
import { styled } from "styled-system/jsx";

export const StyledTableHeader = styled(Table.Header, {
  base: {
    color: "text.light!",
    fontWeight: "semiBold!",
    fontSize: "xs!",
    lineHeight: "xs!",
    letterSpacing: "0.008em",
  },
});
